module.exports = __webpack_public_path__ + "static/media/icon-blessure.fa3f312a.svg";